import { CouponPaymentPageProps } from 'src/pages/CouponPaymentPage/index'
import styled from 'styled-components'
import {
  Noto_body1_b16,
  Noto_body1_m16,
  Noto_body1_r16,
  Noto_body2_b14,
  Noto_body2_m14,
  Noto_body2_r14,
  Noto_DisPlay2_b32,
} from 'src/styles/fonts/NotoSansKrFonts'

import { ellip } from 'src/styles/mixin'
import { Icon } from 'src/assets/svg/Icon'
import { Typography } from 'src/components/common/Typography'
import { Container } from 'src/components/common/Container'

import { SmallDivider } from 'src/components/common/Divider'
import CouponCircleImage from 'src/components/common/CouponCircleImage'
import RenderIf from 'src/components/common/RenderIf'

const CouponPaymentPageView = ({
  resultContent,
  couponDetailData,
  mainPageNav,
}: CouponPaymentPageProps) => {
  const { title, desc, img, infoList, rePurchaseButton, notiText } = resultContent

  const { BrandName, CouponName, CouponImage, CouponType } = couponDetailData!
  const isHotDeal = CouponType === 1

  const noti = isHotDeal ? (notiText?.hotdeal ?? notiText?.default) : notiText?.default
  const infoNoti = noti?.[0]
  const supportNoti = noti?.[1]

  return (
    <S.CouponPaymentPageContainer $option={'flex_column'}>
      <S.CouponPaymentContents $option="flex_column">
        <S.CouponPaymentPrimaryContents $option="flex_column" $row_gap="10px">
          <S.CouponPaymentPrimaryWrap $option="flex_row" $column_gap="10px">
            <S.CouponPaymentStatusText $fontStyle={Noto_DisPlay2_b32}>
              {title}
            </S.CouponPaymentStatusText>
            <RenderIf when={!!img}>
              <S.CouponPaymentStatusImg src={img!?.src} $imgWidth={img!?.width} alt="아이콘" />
            </RenderIf>
          </S.CouponPaymentPrimaryWrap>
          <S.CouponPaymentStatusText $fontStyle={Noto_body1_r16} $color="var(--black-50)">
            {desc}
          </S.CouponPaymentStatusText>
        </S.CouponPaymentPrimaryContents>
        <S.CouponPaymentCouponInfoContents $option="flex_column">
          <CouponCircleImage src={CouponImage} />
          <S.CouponInfoContainer $option="flex_column" $row_gap="2px">
            <Typography $fontStyle={Noto_body2_m14} $color="var(--black-50)">
              [{BrandName}]
            </Typography>
            <S.CouponPaymentCouponName $fontStyle={Noto_body1_b16}>
              {CouponName}
            </S.CouponPaymentCouponName>
          </S.CouponInfoContainer>
          <S.CouponPaymentInfoWrap $option="flex_column" $row_gap="10px">
            {infoList?.map(({ text, value, topDivider, valueFontStyle, bottomDivider }) => (
              <Container $option="flex_column" key={text} $row_gap="10px">
                {topDivider && <SmallDivider />}
                <S.InfoListItemWrap $option="flex_row_space_between">
                  <Typography $fontStyle={Noto_body1_m16} $color="var(--black-50)">
                    {text}
                  </Typography>
                  <Typography $style={valueFontStyle}>{value}</Typography>
                </S.InfoListItemWrap>
                {bottomDivider && <SmallDivider />}
              </Container>
            ))}
          </S.CouponPaymentInfoWrap>
          <RenderIf when={!!infoNoti}>
            <S.CouponPaymentInfoNotiContainer
              $option="flex_column"
              $row_gap="2px"
              $text_align={infoNoti?.align}
            >
              <Typography $fontStyle={Noto_body2_b14} $color={infoNoti?.color || 'var(--black-50)'}>
                {infoNoti?.title}
              </Typography>
              <Typography $fontStyle={Noto_body2_r14} $color="var(--black-50)">
                {infoNoti?.desc}
              </Typography>
            </S.CouponPaymentInfoNotiContainer>
          </RenderIf>
        </S.CouponPaymentCouponInfoContents>
        <RenderIf when={!!supportNoti}>
          <S.CouponPaymentSupportNotiContainer
            $option="flex_column"
            $row_gap="2px"
            $text_align={supportNoti?.align}
          >
            <Typography
              $fontStyle={Noto_body2_b14}
              $color={supportNoti?.color || 'var(--black-50)'}
            >
              {supportNoti?.title}
            </Typography>
            <Typography $fontStyle={Noto_body2_r14} $color="var(--black-50)">
              {supportNoti?.desc}
            </Typography>
          </S.CouponPaymentSupportNotiContainer>
        </RenderIf>
        <S.CouponPaymentBtnContainer $option="flex_column" $row_gap="14px">
          <RenderIf when={!!rePurchaseButton}>
            <S.CouponPaymentRePurChaseButton onClick={rePurchaseButton?.onClickFn}>
              {rePurchaseButton?.text}
            </S.CouponPaymentRePurChaseButton>
          </RenderIf>
          <S.CouponPaymentGoHome $option="flex_row" $column_gap="2px" onClick={mainPageNav}>
            <Typography $fontStyle={Noto_body2_b14} $color="var(--black-50)">
              홈으로 이동
            </Typography>
            <Icon.Arrow size="16" rotate="right" color="var(--black-50)" />
          </S.CouponPaymentGoHome>
        </S.CouponPaymentBtnContainer>
      </S.CouponPaymentContents>
    </S.CouponPaymentPageContainer>
  )
}
export default CouponPaymentPageView

const S = {
  CouponPaymentPageContainer: styled(Container)`
    flex: 1;
    background-color: var(--black-4);
    align-items: center;
    justify-content: center;
    padding: 20px;
  `,
  CouponPaymentContents: styled(Container)`
    max-width: 360px;
  `,
  CouponPaymentPrimaryContents: styled(Container)`
    gap: 10px;
    padding: 0 20px;
    margin-bottom: 40px;
    text-align: left;
  `,
  CouponPaymentPrimaryWrap: styled(Container)`
    align-items: center;
  `,
  CouponPaymentStatusText: styled(Typography)`
    white-space: pre-wrap;
  `,
  CouponPaymentCouponInfoContents: styled(Container)`
    border-radius: 20px;
    background-color: var(--white);
    padding: 25px 30px;
  `,
  CouponInfoContainer: styled(Container)`
    text-align: center;
    margin-top: 14px;
  `,
  CouponPaymentCouponName: styled(Typography)`
    ${ellip('line1')};
    text-align: center;
  `,
  CouponPaymentInfoNotiContainer: styled(Container)<{ $text_align: string | undefined }>`
    text-align: ${({ $text_align }) => $text_align || 'left'};
    white-space: pre-line;
  `,
  InfoListItemWrap: styled(Container)`
    align-items: center;
  `,
  CouponPaymentInfoWrap: styled(Container)`
    margin: 20px 0 10px;
  `,
  CouponPaymentGoHome: styled(Container)`
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    width: fit-content;
    cursor: pointer;
  `,
  CouponPaymentStatusImg: styled.img<{ $imgWidth: string }>`
    display: flex;
    width: ${(props) => props.$imgWidth};
  `,
  CouponPaymentSupportNotiContainer: styled(Container)<{ $text_align: string | undefined }>`
    padding: 25px 30px;
    margin-top: 10px;
    border-radius: 20px;
    background-color: var(--white);
    text-align: ${({ $text_align }) => $text_align || 'left'};
    white-space: pre-line;
  `,
  CouponPaymentBtnContainer: styled(Container)`
    margin-top: 30px;
  `,
  CouponPaymentRePurChaseButton: styled.button`
    display: inline-block;
    width: calc(100% - 60px);
    margin: 0 auto;
    height: 48px;
    border-radius: 12px;
    text-align: center;
    background-color: var(--brand-50);
    ${Noto_body1_b16};
    color: var(--white);
  `,
}
